import React from "react";

function Icon({ children }) {
  return (
    <span className="hs-shot-ico" aria-hidden="true">
      {children}
    </span>
  );
}

function MapIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <path d="M4 6l5-2 6 2 5-2v14l-5 2-6-2-5 2V6z" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M9 4v14M15 6v14" fill="none" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    </Icon>
  );
}

function ChartIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <path d="M5 19V9M12 19V5M19 19v-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </Icon>
  );
}

function ColumnsIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <rect x="3" y="5" width="5" height="14" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <rect x="10" y="5" width="5" height="14" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <rect x="17" y="5" width="5" height="14" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    </Icon>
  );
}

function CapIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <path d="M3 10l9-4 9 4-9 4-9-4z" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M7 12v4c2 2 8 2 10 0v-4" fill="none" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    </Icon>
  );
}

function ExamIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <rect x="5" y="3" width="14" height="18" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8 8h8M8 12h8M8 16h5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    </Icon>
  );
}

function PathIcon() {
  return (
    <Icon>
      <svg viewBox="0 0 24 24">
        <circle cx="6" cy="7" r="2.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="18" cy="17" r="2.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8 8c4 0 4 8 8 8" fill="none" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    </Icon>
  );
}

export function SnapshotHome() {
  return (
    <div className="hs-shot hs-shot--panel hs-shot--clip">
      <video
        className="hs-shot-clip"
        src="/home-clips/set-home.mp4?v=15"
        poster="/home-clips/set-home.jpg?v=15"
        autoPlay
        muted
        loop
        playsInline
        aria-label="Enter a postcode or place a pin on the map"
      />
      <div className="hs-shot-clip-caption">
        <MapIcon />
        <span>Postcode or pin — set home on the map</span>
      </div>
    </div>
  );
}

export function SnapshotPanel() {
  return (
    <div className="hs-shot hs-shot--panel hs-shot--clip">
      <video
        className="hs-shot-clip"
        src="/home-clips/catchment-tour.mp4?v=2"
        poster="/home-clips/catchment-tour.jpg?v=2"
        autoPlay
        muted
        loop
        playsInline
        aria-label="Exact grammar school catchments shown one at a time on the map"
        onError={(event) => {
          const node = event.currentTarget;
          const img = document.createElement("img");
          img.className = "hs-shot-clip";
          img.alt = "Exact grammar school catchments shown one at a time on the map";
          img.src = "/home-clips/catchment-tour.jpg?v=2";
          img.onerror = () => {
            img.onerror = null;
            img.src = "/home-clips/catchment-bucks-reading.jpg?v=1";
          };
          node.replaceWith(img);
        }}
      />
      <div className="hs-shot-clip-caption">
        <MapIcon />
        <span>One catchment at a time — fitted to the map</span>
      </div>
    </div>
  );
}

export function SnapshotAlloc() {
  return (
    <div className="hs-shot hs-shot--alloc hs-alloc">
      <div className="hs-alloc-top">
        <div>
          <p className="hs-alloc-kicker">Allocation details</p>
          <strong className="hs-alloc-school">The Tiffin Girls&apos; School</strong>
          <em className="hs-alloc-meta">Girls · Designated Area · Year 7</em>
        </div>
        <span className="hs-alloc-badge">2025 entry</span>
      </div>

      <div className="hs-alloc-funnel" aria-hidden="true">
        <div className="hs-alloc-funnel-step hs-alloc-funnel-step--teal">
          <span>Stage one</span>
          <strong>1,498</strong>
          <em>girls sat the first papers</em>
        </div>
        <div className="hs-alloc-funnel-gap">
          <b>32%</b>
          <span>invited on</span>
        </div>
        <div className="hs-alloc-funnel-step hs-alloc-funnel-step--sky">
          <span>Stage two</span>
          <strong>475</strong>
          <em>sat the second papers</em>
        </div>
        <div className="hs-alloc-funnel-gap">
          <b>38%</b>
          <span>of stage two</span>
        </div>
        <div className="hs-alloc-funnel-step hs-alloc-funnel-step--amber">
          <span>Places</span>
          <strong>180</strong>
          <em>Year 7 places offered</em>
        </div>
      </div>

      <div className="hs-alloc-multiples">
        <div className="hs-alloc-multiple hs-alloc-multiple--ember">
          <strong>8.3×</strong>
          <span>Stage one sitters per place</span>
        </div>
        <div className="hs-alloc-multiple hs-alloc-multiple--navy">
          <strong>2.6×</strong>
          <span>Stage two sitters per place</span>
        </div>
      </div>

      <div className="hs-alloc-reach hs-alloc-reach--compact">
        <div className="hs-alloc-reach-head">
          <span>Where offers landed</span>
          <strong>All 180 inside the Designated Area</strong>
        </div>
      </div>

      <div className="hs-alloc-years-table" aria-hidden="true">
        <div className="hs-alloc-years-head">
          <span>Entry year</span>
          <span>Stage one</span>
          <span>Stage two</span>
          <span>Places</span>
        </div>
        <div className="hs-alloc-years-row">
          <em>2026</em>
          <span>1,468</span>
          <span>474</span>
          <span>180</span>
        </div>
        <div className="hs-alloc-years-row is-on">
          <em>2025</em>
          <span>1,498</span>
          <span>475</span>
          <span>180</span>
        </div>
        <div className="hs-alloc-years-row">
          <em>2024</em>
          <span>1,485</span>
          <span>465</span>
          <span>180</span>
        </div>
      </div>

      <div className="hs-alloc-chips">
        <div className="hs-alloc-chip hs-alloc-chip--teal">
          <span>Inner Area · stage one</span>
          <strong>255</strong>
        </div>
        <div className="hs-alloc-chip hs-alloc-chip--amber">
          <span>Pupil premium · stage one</span>
          <strong>71</strong>
        </div>
        <div className="hs-alloc-chip hs-alloc-chip--navy">
          <span>Appeals heard / won</span>
          <strong>10 / 0</strong>
        </div>
      </div>

      <p className="hs-shot-note">
        School-published figures for 2025 entry — context for how tight it was, not a forecast for your child.
      </p>
    </div>
  );
}

export function SnapshotRank() {
  return (
    <div className="hs-shot hs-shot--rank">
      <div className="hs-shot-bar">
        <strong>
          <ChartIcon /> Ranking
        </strong>
        <span>163 schools</span>
      </div>
      <div className="hs-shot-table-wrap">
        <table className="hs-shot-table hs-shot-rk">
          <thead>
            <tr className="hs-shot-rk-groups">
              <th className="hs-shot-rk-school" rowSpan={2}>
                School
              </th>
              <th className="hs-shot-rk-g hs-shot-rk-g--gcse" colSpan={3}>
                GCSE
              </th>
              <th className="hs-shot-rk-g hs-shot-rk-g--alevel" colSpan={3}>
                A level
              </th>
              <th className="hs-shot-rk-g hs-shot-rk-g--after" colSpan={2}>
                Leavers
              </th>
              <th className="hs-shot-rk-g hs-shot-rk-g--ofsted" rowSpan={2}>
                Ofsted
              </th>
              <th className="hs-shot-rk-g hs-shot-rk-g--miles" rowSpan={2}>
                Miles
              </th>
            </tr>
            <tr className="hs-shot-rk-cols">
              <th className="hs-shot-rk-b hs-shot-rk-b--gcse">Rank</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--gcse">Att. 8</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--gcse">Grade 9</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--alevel">Rank</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--alevel">Points</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--alevel">A*</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--after">University</th>
              <th className="hs-shot-rk-b hs-shot-rk-b--after">Oxbridge</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>Wilson&apos;s School</strong>
                <em>Sutton · Boys</em>
              </td>
              <td className="hs-shot-rk-b--gcse">1</td>
              <td className="hs-shot-rk-b--gcse">85.2</td>
              <td className="hs-shot-rk-b--gcse">48%</td>
              <td className="hs-shot-rk-b--alevel">1</td>
              <td className="hs-shot-rk-b--alevel">52.8</td>
              <td className="hs-shot-rk-b--alevel">42%</td>
              <td className="hs-shot-rk-b--after">93%</td>
              <td className="hs-shot-rk-b--after">37</td>
              <td className="hs-shot-rk-b--ofsted">Outstanding</td>
              <td className="hs-shot-rk-b--miles">5.8</td>
            </tr>
            <tr>
              <td>
                <strong>Queen Elizabeth&apos;s</strong>
                <em>Barnet · Boys</em>
              </td>
              <td className="hs-shot-rk-b--gcse">2</td>
              <td className="hs-shot-rk-b--gcse">84.1</td>
              <td className="hs-shot-rk-b--gcse">46%</td>
              <td className="hs-shot-rk-b--alevel">2</td>
              <td className="hs-shot-rk-b--alevel">52.1</td>
              <td className="hs-shot-rk-b--alevel">41%</td>
              <td className="hs-shot-rk-b--after">94%</td>
              <td className="hs-shot-rk-b--after">44</td>
              <td className="hs-shot-rk-b--ofsted">Outstanding</td>
              <td className="hs-shot-rk-b--miles">4.2</td>
            </tr>
            <tr className="is-on">
              <td>
                <strong>The Tiffin Girls&apos;</strong>
                <em>Kingston · Girls</em>
              </td>
              <td className="hs-shot-rk-b--gcse">3</td>
              <td className="hs-shot-rk-b--gcse">83.6</td>
              <td className="hs-shot-rk-b--gcse">45%</td>
              <td className="hs-shot-rk-b--alevel">3</td>
              <td className="hs-shot-rk-b--alevel">51.4</td>
              <td className="hs-shot-rk-b--alevel">39%</td>
              <td className="hs-shot-rk-b--after">92%</td>
              <td className="hs-shot-rk-b--after">15</td>
              <td className="hs-shot-rk-b--ofsted">Outstanding</td>
              <td className="hs-shot-rk-b--miles">3.1</td>
            </tr>
            <tr>
              <td>
                <strong>The Latymer School</strong>
                <em>Enfield · Mixed</em>
              </td>
              <td className="hs-shot-rk-b--gcse">4</td>
              <td className="hs-shot-rk-b--gcse">82.9</td>
              <td className="hs-shot-rk-b--gcse">43%</td>
              <td className="hs-shot-rk-b--alevel">5</td>
              <td className="hs-shot-rk-b--alevel">49.6</td>
              <td className="hs-shot-rk-b--alevel">36%</td>
              <td className="hs-shot-rk-b--after">91%</td>
              <td className="hs-shot-rk-b--after">—</td>
              <td className="hs-shot-rk-b--ofsted">Outstanding</td>
              <td className="hs-shot-rk-b--miles">6.4</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="hs-shot-note">Sort by GCSE, A level, Ofsted, destinations, or miles from home.</p>
    </div>
  );
}

function SnapshotBestTick() {
  return (
    <svg className="hs-shot-cp-tick" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
      <circle className="hs-shot-cp-tick-disc" cx="10" cy="10" r="9" />
      <path
        className="hs-shot-cp-tick-path"
        d="M5.6 10.35l2.85 2.85 6-6.7"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SnapshotCpCell({ children, best = false, col }) {
  return (
    <div className={`hs-shot-cp-cell hs-shot-cp-col--${col}${best ? " is-best" : ""}`}>
      {best ? (
        <span className="hs-shot-cp-tick-slot">
          <SnapshotBestTick />
        </span>
      ) : (
        <span className="hs-shot-cp-tick-slot" />
      )}
      <span className="hs-shot-cp-val">{children}</span>
    </div>
  );
}

export function SnapshotCompare() {
  return (
    <div className="hs-shot hs-shot--compare">
      <div className="hs-shot-bar">
        <strong>
          <ColumnsIcon /> Compare
        </strong>
        <span>3 of 4 selected</span>
      </div>
      <div className="hs-shot-cp">
        <div className="hs-shot-cp-corner">Metric</div>
        <div className="hs-shot-cp-head hs-shot-cp-col--0">
          <strong>Wilson&apos;s School</strong>
          <em className="hs-shot-cp-wins is-lead">Best in 2 of 4</em>
        </div>
        <div className="hs-shot-cp-head hs-shot-cp-col--1">
          <strong>The Tiffin Girls&apos;</strong>
          <em className="hs-shot-cp-wins">Best in 2 of 4</em>
        </div>
        <div className="hs-shot-cp-head hs-shot-cp-col--2">
          <strong>Pate&apos;s Grammar</strong>
          <em className="hs-shot-cp-wins">Best in 0 of 4</em>
        </div>

        <div className="hs-shot-cp-metric">GCSE rank</div>
        <SnapshotCpCell col={0} best>
          1
        </SnapshotCpCell>
        <SnapshotCpCell col={1}>3</SnapshotCpCell>
        <SnapshotCpCell col={2}>5</SnapshotCpCell>

        <div className="hs-shot-cp-metric">Catchment</div>
        <SnapshotCpCell col={0}>Open</SnapshotCpCell>
        <SnapshotCpCell col={1}>In catchment</SnapshotCpCell>
        <SnapshotCpCell col={2}>Outside</SnapshotCpCell>

        <div className="hs-shot-cp-metric">Miles from home</div>
        <SnapshotCpCell col={0}>5.8</SnapshotCpCell>
        <SnapshotCpCell col={1} best>
          3.1
        </SnapshotCpCell>
        <SnapshotCpCell col={2}>48.2</SnapshotCpCell>

        <div className="hs-shot-cp-metric">11+ exam subjects</div>
        <SnapshotCpCell col={0}>English · Maths · VR · NVR</SnapshotCpCell>
        <SnapshotCpCell col={1}>English · Maths</SnapshotCpCell>
        <SnapshotCpCell col={2}>English · Maths · VR</SnapshotCpCell>

        <div className="hs-shot-cp-group">GCSE</div>
        <div className="hs-shot-cp-group-fill" />
        <div className="hs-shot-cp-group-fill" />
        <div className="hs-shot-cp-group-fill" />

        <div className="hs-shot-cp-metric">Attainment 8</div>
        <SnapshotCpCell col={0} best>
          85.2
        </SnapshotCpCell>
        <SnapshotCpCell col={1}>83.6</SnapshotCpCell>
        <SnapshotCpCell col={2}>82.9</SnapshotCpCell>

        <div className="hs-shot-cp-metric">Grade 9</div>
        <SnapshotCpCell col={0}>45%</SnapshotCpCell>
        <SnapshotCpCell col={1} best>
          46%
        </SnapshotCpCell>
        <SnapshotCpCell col={2}>43%</SnapshotCpCell>
      </div>
      <p className="hs-shot-note">Same measures side by side — overview and GCSE.</p>
    </div>
  );
}

export function SnapshotOxbridge() {
  return (
    <div className="hs-shot hs-shot--oxbridge hs-oxb">
      <div className="hs-oxb-top">
        <div>
          <p className="hs-oxb-kicker">Oxbridge &amp; destinations</p>
          <strong className="hs-oxb-school">Wilson&apos;s School</strong>
          <em className="hs-oxb-meta">Boys · Sutton · Sixth form leavers</em>
        </div>
        <span className="hs-oxb-badge">Post-18</span>
      </div>

      <div className="hs-oxb-heroes">
        <div className="hs-oxb-hero hs-oxb-hero--blue">
          <span>Oxbridge offers</span>
          <strong>37</strong>
          <em>School-published count</em>
        </div>
        <div className="hs-oxb-hero hs-oxb-hero--teal">
          <span>Higher education</span>
          <strong>93%</strong>
          <em>DfE leavers destinations</em>
        </div>
      </div>

      <div className="hs-oxb-dest">
        <div className="hs-oxb-dest-head">
          <span>Where leavers went</span>
          <em>DfE sustained destinations</em>
        </div>
        <div className="hs-oxb-bars" aria-hidden="true">
          <div className="hs-oxb-bar">
            <div className="hs-oxb-bar-label">
              <span>Higher education</span>
              <b>93%</b>
            </div>
            <i>
              <u style={{ width: "93%" }} />
            </i>
          </div>
        </div>
        <div className="hs-oxb-dest-also">
          <span>Also in the school file</span>
          <div>
            <em>Further education</em>
            <em>Apprenticeships</em>
            <em>Employment</em>
          </div>
        </div>
      </div>

      <div className="hs-oxb-sources">
        <div className="hs-oxb-source hs-oxb-source--blue">
          <span>Oxbridge source</span>
          <strong>School page</strong>
        </div>
        <div className="hs-oxb-source hs-oxb-source--teal">
          <span>Destinations source</span>
          <strong>DfE extract</strong>
        </div>
        <div className="hs-oxb-source hs-oxb-source--slate">
          <span>If missing</span>
          <strong>We leave blank</strong>
        </div>
      </div>

      <p className="hs-shot-note">
        Sixth-form context beside GCSE and A level — never a forecast for your child.
      </p>
    </div>
  );
}

export function SnapshotExams() {
  return (
    <div className="hs-shot hs-shot--exams hs-exam">
      <div className="hs-exam-top">
        <div>
          <p className="hs-exam-kicker">Exam details</p>
          <strong className="hs-exam-school">Gravesend Grammar School</strong>
          <em className="hs-exam-meta">Boys · Kent · Year 7</em>
        </div>
        <span className="hs-exam-shared">Kent Test</span>
      </div>

      <div className="hs-exam-papers">
        <article className="hs-exam-paper hs-exam-paper--ember">
          <header>
            <b>01</b>
            <div>
              <strong>Reasoning paper</strong>
              <em>Multiple choice · GL Assessment</em>
            </div>
          </header>
          <div className="hs-exam-subjects">
            <span className="is-on hs-exam-chip--ember">Verbal reasoning</span>
            <span className="is-on hs-exam-chip--amber">Non-verbal</span>
            <span className="is-on hs-exam-chip--sky">Spatial</span>
          </div>
          <p>One shared reasoning paper for Kent grammars — not a Gravesend-only sitting.</p>
        </article>
        <article className="hs-exam-paper hs-exam-paper--navy">
          <header>
            <b>02</b>
            <div>
              <strong>English &amp; maths</strong>
              <em>Two more papers · same day</em>
            </div>
          </header>
          <div className="hs-exam-subjects">
            <span className="is-on hs-exam-chip--navy">English</span>
            <span className="is-on hs-exam-chip--teal">Maths</span>
          </div>
          <p>Reading, writing skills, and maths — familiarisation materials published by Kent each year.</p>
        </article>
      </div>

      <div className="hs-exam-subject-grid" aria-hidden="true">
        <div className="hs-exam-subject-card hs-exam-subject-card--ember">
          <span>VR</span>
          <strong>Verbal reasoning</strong>
        </div>
        <div className="hs-exam-subject-card hs-exam-subject-card--amber">
          <span>NVR</span>
          <strong>Non-verbal</strong>
        </div>
        <div className="hs-exam-subject-card hs-exam-subject-card--sky">
          <span>Spatial</span>
          <strong>Spatial reasoning</strong>
        </div>
        <div className="hs-exam-subject-card hs-exam-subject-card--navy">
          <span>Eng</span>
          <strong>English</strong>
        </div>
        <div className="hs-exam-subject-card hs-exam-subject-card--teal">
          <span>Ma</span>
          <strong>Maths</strong>
        </div>
      </div>

      <ol className="hs-exam-timeline" aria-hidden="true">
        <li className="is-done hs-exam-tl--teal">
          <i />
          <strong>Register</strong>
          <span>1 Jun–1 Jul</span>
        </li>
        <li className="is-on hs-exam-tl--ember">
          <i />
          <strong>Sit Kent Test</strong>
          <span>September</span>
        </li>
        <li className="hs-exam-tl--amber">
          <i />
          <strong>Results</strong>
          <span>Mid Oct</span>
        </li>
        <li className="hs-exam-tl--navy">
          <i />
          <strong>CAF / SCAF</strong>
          <span>Early Nov</span>
        </li>
      </ol>

      <div className="hs-exam-chips">
        <div className="hs-exam-chip-stat hs-exam-chip-stat--teal">
          <span>Shared with</span>
          <strong>30+ Kent grammars</strong>
        </div>
        <div className="hs-exam-chip-stat hs-exam-chip-stat--amber">
          <span>Selective result</span>
          <strong>Gateway only</strong>
        </div>
        <div className="hs-exam-chip-stat hs-exam-chip-stat--navy">
          <span>Extra route</span>
          <strong>Headteacher assessment</strong>
        </div>
      </div>

      <div className="hs-exam-foot">
        <span>One Kent Test — still name each school on the CAF</span>
        <em>Confirm dates each year</em>
      </div>
    </div>
  );
}

const DEADLINE_STEPS = [
  { when: "Varies", title: "In catchment by", hint: "Stay-in-catchment date", state: "done", tone: "emerald" },
  { when: "Jul–Sep", title: "Register", hint: "School test entry", state: "current", tone: "blue" },
  { when: "Sep", title: "Stage one", hint: "First papers", state: "todo", tone: "indigo" },
  { when: "Oct", title: "Stage two", hint: "Invite / results", state: "todo", tone: "amber" },
  { when: "31 Oct", title: "CAF deadline", hint: "Name schools", state: "deadline", tone: "coral" },
  { when: "1 Mar", title: "Offer day", hint: "Places land", state: "todo", tone: "violet" },
];

export function SnapshotDeadlines() {
  return (
    <div className="hs-shot hs-shot--deadlines hs-shot--rail">
      <div className="hs-rail-head">
        <p className="hs-rail-kicker">Year 7 key dates</p>
        <p className="hs-rail-status">
          <span className="hs-rail-pill">Next up</span>
          Register for tests
        </p>
      </div>
      <ol className="hs-rail" aria-label="Year 7 path from catchment residence date to offer day">
        {DEADLINE_STEPS.map((step, index) => (
          <li key={step.title} className={`hs-rail-step is-${step.state} hs-rail-step--${step.tone}`}>
            {index > 0 ? <span className="hs-rail-connector" aria-hidden="true" /> : null}
            <span className="hs-rail-marker" aria-hidden="true">
              {step.state === "done" ? "✓" : step.state === "deadline" ? "!" : index + 1}
            </span>
            <div className="hs-rail-copy">
              <em>{step.when}</em>
              <strong>{step.title}</strong>
              <span>{step.hint}</span>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}

export function SnapshotGuide() {
  return (
    <div className="hs-shot hs-shot--guide hs-guide">
      <div className="hs-guide-head">
        <p className="hs-guide-kicker">School guide</p>
        <strong>Wilson&apos;s School · Year 7</strong>
        <em>What to do next for this school — catchment, apply, exams, offer day</em>
      </div>

      <ol className="hs-guide-path">
        <li className="is-done hs-guide-step--teal">
          <span className="hs-guide-node" aria-hidden="true">
            <PathIcon />
          </span>
          <div className="hs-guide-body">
            <strong>Catchment</strong>
            <p>Open / priority standing on the map for your home pin.</p>
            <div className="hs-guide-viz hs-guide-viz--map" aria-hidden="true">
              <i />
              <i />
              <i />
            </div>
          </div>
        </li>
        <li className="is-on hs-guide-step--ember">
          <span className="hs-guide-node" aria-hidden="true">
            <ExamIcon />
          </span>
          <div className="hs-guide-body">
            <strong>How to apply</strong>
            <p>Register for tests, then name the school on the CAF.</p>
            <ul className="hs-guide-checks">
              <li className="is-tick">Register with the school</li>
              <li className="is-tick">CAF preference order</li>
              <li>Evidence if asked</li>
            </ul>
          </div>
        </li>
        <li className="hs-guide-step--amber">
          <span className="hs-guide-node" aria-hidden="true">
            <ChartIcon />
          </span>
          <div className="hs-guide-body">
            <strong>Exams &amp; place order</strong>
            <p>Papers, dates, and how this school ranks eligible children.</p>
          </div>
        </li>
        <li className="hs-guide-step--navy">
          <span className="hs-guide-node" aria-hidden="true">
            <CapIcon />
          </span>
          <div className="hs-guide-body">
            <strong>Offer day</strong>
            <p>1 March — what an offer means next for this school.</p>
            <div className="hs-guide-viz hs-guide-viz--offer" aria-hidden="true">
              <span>1 Mar</span>
            </div>
          </div>
        </li>
      </ol>
    </div>
  );
}

const SNAPSHOTS = {
  home: SnapshotHome,
  panel: SnapshotPanel,
  alloc: SnapshotAlloc,
  rank: SnapshotRank,
  compare: SnapshotCompare,
  oxbridge: SnapshotOxbridge,
  exams: SnapshotExams,
  deadlines: SnapshotDeadlines,
  guide: SnapshotGuide,
};

export default function DepthSnapshot({ kind }) {
  const Comp = SNAPSHOTS[kind] || SnapshotPanel;
  return <Comp />;
}
